import { theme } from '@faxi/web-component-library';
import { flex, fontSize, phablet } from '@faxi/web-css-utilities';
import styled, { css } from 'styled-components';

const StyledSignIfCard = styled.div`
  background-color: white;
  max-width: 600px;

  border-radius: ${theme.sizes.SIZE_8};
  padding: ${theme.sizes.SIZE_32};

  .cedolauto-sign-if-card {
    &__title {
      margin-bottom: ${theme.sizes.SIZE_24};
      font-size: ${theme.sizes.SIZE_24};

      margin: 0 0 8px 60px;
      font-weight: bold;
      text-transform: uppercase;
    }

    &__content {
      list-style: none;
      padding: 0;
      margin: ${theme.sizes.SIZE_24} 0;

      li {
        ${flex('row', 'flex-start', 'center')};
        gap: ${theme.sizes.SIZE_32};

        margin-bottom: ${theme.sizes.SIZE_16};
        ${fontSize(theme.fontSizes.FONT_24, '40px')}

        .wcl-icon {
          ${fontSize(theme.fontSizes.FONT_34)};

          ${phablet(css`
            ${fontSize(theme.fontSizes.FONT_24)};
          `)};
        }

        ${phablet(css`
          ${fontSize(theme.fontSizes.FONT_18, '24px')};
          gap: ${theme.sizes.SIZE_24};
        `)};
      }
    }

    &__actions {
      ${flex('row', 'flex-end', 'center')};

      button {
        text-transform: uppercase;

        ${phablet(css`
          width: 100%;
        `)};
      }
    }
  }
`;

export { StyledSignIfCard };
